import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.652 3.272A3 3 0 0 1 7.562 1h8.877a3 3 0 0 1 2.91 2.272l3 12A3 3 0 0 1 19.44 19H13v2h6a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h6v-2H4.562a3 3 0 0 1-2.91-3.728zM13 17h6.438a1 1 0 0 0 .97-1.242L19.22 11H13zm-2-6v6H4.562a1 1 0 0 1-.97-1.242L4.782 11zm2-2h5.719l-1.31-5.243A1 1 0 0 0 16.438 3H13zm-2-6v6H5.28l1.31-5.243A1 1 0 0 1 7.563 3h3.439Z"
    }, null, -1)
  ]))]))
}
export default { render: render }